var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _path, _circle12, _circle13, _circle14, _circle15, _circle16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstances = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentColor",
  width: 37,
  height: 38,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 759 856.7",
  "aria-hidden": "true",
  focusable: "false"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 184.1,
  cy: 744.6,
  r: 22.7
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 115.2,
  cy: 744.6,
  r: 22.7
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 115.2,
  cy: 198.7,
  r: 22.7
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 252.9,
  cy: 744.6,
  r: 22.7
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 252.9,
  cy: 198.7,
  r: 22.7
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 643.8,
  cy: 198.7,
  r: 22.7
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 184.1,
  cy: 198.7,
  r: 22.7
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 184.1,
  cy: 380.6,
  r: 22.7
})), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  cx: 643.8,
  cy: 380.6,
  r: 22.7
})), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
  cx: 252.9,
  cy: 380.6,
  r: 22.7
})), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
  cx: 321.8,
  cy: 380.6,
  r: 22.7
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M748.5 106.2c-1.5-6.5-6-11.7-11.9-14.4L623.8 7.5c-3.5-2.6-7.6-4-11.9-4.2-1.1 0-108.2-3.3-232.4-3.3S148.2 3.3 147.1 3.3c-4.3.1-8.5 1.6-11.9 4.2L22.4 91.8c-5.8 2.6-10.3 7.7-11.8 14.2-.4 1.8-10.6 44.8-10.6 92.2 0 43.7 8.7 83.8 10.3 91-1.7 7.2-10.3 47.2-10.3 91 0 43.7 8.7 83.7 10.3 91-1.7 7.2-10.3 47.2-10.3 91 0 43.7 8.7 83.7 10.3 91-1.7 7.2-10.3 47.2-10.3 91 0 47.3 10.2 90.3 10.6 92.1 2.2 9.2 10.3 15.8 19.8 16.1 1.6 0 164.2 4.3 349.1 4.3s347.4-4.2 349.1-4.3c9.6-.2 17.8-6.9 19.9-16.3.4-1.9 10.5-46.5 10.5-92 0-42.4-8.8-84-10.3-91 1.5-7 10.3-48.6 10.3-91s-8.8-84-10.3-91c1.5-7 10.3-48.6 10.3-91s-8.8-84-10.3-91c1.5-7 10.3-48.6 10.3-91 0-45.5-10.1-90.1-10.5-91.9zM155 45.1c25.1-.7 118.6-3.1 224.5-3.1 106 0 199.4 2.4 224.5 3.1l58 43.3c-64.4-1.2-168.6-2.8-282.5-2.8S161.4 87.2 97 88.4l58-43.3zM48.3 131.4c45.8-1.1 180.1-3.8 331.2-3.8s285.3 2.8 331.2 3.8c2.8 15.8 6.4 41.4 6.4 66.7 0 25.2-3.6 50.9-6.4 66.7-33.3.8-113.2 2.4-211.5 3.3-37.6-.3-78-.5-119.7-.5s-82 .2-119.6.5c-98.4-.9-178.3-2.5-211.6-3.3-2.7-15.5-6.3-40.6-6.3-66.7 0-26 3.5-51.2 6.3-66.7zm662.4 679.3c-46.1 1.1-181.3 3.8-331.2 3.8-150 0-285.2-2.8-331.2-3.8C45.6 795.2 42 770 42 744c0-26.1 3.6-51.2 6.3-66.7 33.2-.8 112.7-2.4 211.3-3.3 37.8.3 78.3.5 119.9.5 41.5 0 81.9-.2 119.6-.5 98.7.9 178.3 2.5 211.5 3.3 2.8 15.9 6.4 41.5 6.4 66.7 0 25.3-3.6 50.9-6.3 66.7zm0-181.9c-33.3.8-113.1 2.4-211.2 3.3-37.7-.3-78.1-.5-119.9-.5s-82.2.2-119.9.5c-98.3-.9-178-2.5-211.3-3.3-2.7-15.5-6.3-40.7-6.3-66.7 0-26.1 3.6-51.2 6.3-66.7 33.2-.8 112.7-2.4 211.3-3.3 37.8.3 78.3.5 119.9.5 41.5 0 81.9-.2 119.6-.5 98.7.9 178.3 2.5 211.5 3.3 2.8 15.9 6.4 41.5 6.4 66.7-.1 25.2-3.7 50.8-6.4 66.7zm0-182c-33.3.8-113.1 2.4-211.2 3.3-37.7-.3-78.1-.5-119.9-.6-41.8 0-82.2.2-119.9.5-98.3-.9-178.1-2.5-211.3-3.3-2.7-15.5-6.3-40.6-6.3-66.7s3.6-51.2 6.3-66.7c33.2-.8 112.8-2.4 211.6-3.3 37.7.3 78.1.5 119.6.5 41.4 0 81.7-.2 119.4-.5 98.8.9 178.5 2.5 211.8 3.3 2.8 15.8 6.4 41.4 6.4 66.7-.2 25.3-3.8 50.9-6.5 66.8z"
})), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
  cx: 184.1,
  cy: 562.6,
  r: 22.7
})), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
  cx: 115.2,
  cy: 380.6,
  r: 22.7
})), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
  cx: 643.8,
  cy: 744.6,
  r: 22.7
})), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
  cx: 115.2,
  cy: 562.6,
  r: 22.7
})), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
  cx: 643.8,
  cy: 562.5,
  r: 22.7
})));
export default SvgInstances;